window.addEventListener('load', () => {
  class PickupHeader extends HTMLElement {
    constructor() {
      super();
      this.unique_id = this.getAttribute('data-unique-id');
      this.modal = this.closest('x-modal.modal--pickup');
      this.mq = window.matchMedia('(max-width: 700px)');
      this.observer = null;
      this.isSetup = false;
      this.hasBeenVisible = false;
      
      // Bind methods once
      this.setup = this.setup.bind(this);
      this.handleATBClick = this.handleATBClick.bind(this);
    }

    destroy() {
      if (!this.isSetup) return;
      
      const atbEl = this.querySelector('buy-buttons button[type="submit"]');
      if (atbEl) {
        atbEl.removeEventListener('click', this.handleATBClick);
      }
      
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      
      this.classList.remove('pickup__header--display');
      this.style.display = null;
      
      this.isSetup = false;
      this.hasBeenVisible = false;
    }

    handleATBClick() {
      requestAnimationFrame(() => {
        setTimeout(() => {
          const modal = document.querySelector('x-modal[open].modal--pickup');
          if (modal) modal.hide();
        }, 500);
      });
    }

    setup() {
      this.destroy();
      
      if (!this.mq.matches || !this.modal?.hasAttribute('open')) return;
      
      // Adjust form attributes
      this.querySelectorAll('[form]').forEach(el => {
        const formAttr = el.getAttribute('form');
        if (!formAttr?.includes('pickup')) {
          el.setAttribute('form', `${formAttr}_pickup`);
        }
      });
      
      // Add event listener to add-to-basket button
      const atbEl = this.querySelector('buy-buttons button[type="submit"]');
      if (atbEl) {
        atbEl.addEventListener('click', this.handleATBClick);
      }
      
      // Setup intersection observer
      this.setupObserver();
      
      this.isSetup = true;
    }
    
    setupObserver() {
      setTimeout(() => {
        const mainATB = this.modal?.querySelector('form button[type="submit"]');
        if (!mainATB) return;
        
        this.observer = new IntersectionObserver(
          (entries) => this.handleIntersection(entries),
          { threshold: 0.1 }
        );
        
        this.observer.observe(mainATB);
      }, 100);
    }
    
    handleIntersection(entries) {
      if (!entries[0]) return;
      
      if (entries[0].isIntersecting) {
        this.hasBeenVisible = true;
        this.style.display = null;
      } else {
        const isAboveViewport = entries[0].boundingClientRect.y < 80;
        this.style.display = (this.hasBeenVisible && isAboveViewport) ? 'flex' : null;
      }
    }
  
    connectedCallback() {
      this.mq.addEventListener('change', this.setup);
      this.setup();
    }
    
    disconnectedCallback() {
      this.mq.removeEventListener('change', this.setup);
      this.destroy();
    }
  }
  
  customElements.define('pickup-header', PickupHeader);
});